import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ClipboardModule } from "ngx-clipboard";

import { AdminLayoutRoutes } from "./admin-layout.routing";
import { NgbDatepickerI18n, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CustomTableComponent } from "../../commons/default-table/custom-table/custom-table.component";
import { ActionsTableComponent } from "src/app/commons/default-table/actions-table/actions-table.component";
import { DefaultAddComponent } from "src/app/commons/default-add/default-add.component";
import { DefaultEditComponent } from "src/app/commons/default-edit/default-edit.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { CustomColTableComponent } from "src/app/commons/default-table/custom-col-table/custom-col-table.component";
import { DefaultPageComponent } from "src/app/commons/default-page/default-page.component";
import { EndpointRelationComponent } from "src/app/commons/endpoint-relation/endpoint-relation.component";
import { OWL_DATE_TIME_LOCALE, OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";

import { SortablejsModule } from "ngx-sortablejs";
import { DashboardComponent } from "src/app/pages/commons/dashboard/dashboard.component";
import { UserProfileComponent } from "src/app/pages/commons/user-profile/user-profile.component";
import { StudiosComponent } from "src/app/pages/manager-studio/studios/studios.component";
import { ReservationsComponent } from "src/app/pages/manager-studio/reservations/reservations.component";
import { ReservationInfoComponent } from "src/app/pages/manager-studio/reservation-info/reservation-info.component";
import { ContactComponent } from "src/app/pages/commons/contact/contact.component";
import { MesFacturesComponent } from "src/app/pages/artist/mes-factures/mes-factures.component";
import { MaReservationDetailsComponent } from "src/app/pages/artist/ma-reservation-details/ma-reservation-details.component";
import { MesReservationsComponent } from "src/app/pages/artist/mes-reservations/mes-reservations.component";
import { MonPlanningComponent } from "src/app/pages/manager-studio/mon-planning/mon-planning.component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { DemoUtilsModule } from "src/app/utils/demo-utils/demo-utils.module";
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { GoogleMapsModule } from '@angular/google-maps';
import { ShortMapComponent } from "src/app/commons/short-map/short-map.component";
import { PaymentCancelComponent } from "src/app/pages/artist/payment-cancel/payment-cancel.component";
import { PaymentFormComponent } from "src/app/pages/artist/payment-form/payment-form.component";
import { PaymentSuccessComponent } from "src/app/pages/artist/payment-success/payment-success.component";
import { PlanningBookingComponent } from "src/app/pages/artist/planning-booking/planning-booking.component";
import { PasscultureHistoriquesComponent } from "src/app/pages/manager-studio/passculture-historiques/passculture-historiques.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { OpeningSlotsComponent } from "src/app/pages/manager-studio/opening-slots/opening-slots.component";
import { I18n, CustomDatepickerI18n } from "src/app/services/translation/I18n.service";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    HttpClientModule,
    NgbModule,
    ClipboardModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    CKEditorModule,
    AutocompleteLibModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SortablejsModule.forRoot({ animation: 150 }),
    GoogleMapsModule,
    GooglePlaceModule,
    DemoUtilsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    })
  ],
  declarations: [
    DashboardComponent,
    UserProfileComponent,
    CustomTableComponent,
    ActionsTableComponent,
    DefaultAddComponent,
    DefaultEditComponent,
    CustomColTableComponent,
    DefaultPageComponent,
    EndpointRelationComponent,
    StudiosComponent,
    ReservationsComponent,
    ReservationInfoComponent,
    ContactComponent,
    MesFacturesComponent,
    MaReservationDetailsComponent,
    MesReservationsComponent,
    MonPlanningComponent,
    ShortMapComponent,
    PaymentCancelComponent,
    PaymentSuccessComponent,
    PlanningBookingComponent,
    PaymentFormComponent,
    PasscultureHistoriquesComponent,
    OpeningSlotsComponent
  ],
  providers: [
    // use french locale
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'fr' },
  ],
})
export class AdminLayoutModule { }
